import { Injectable } from '@angular/core';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { AppConfigService } from 'src/app/core/config/config.service';
import { environment } from 'src/environments/environment';
import { CustomerUri } from 'src/app/core/config/config.model';


@Injectable({ providedIn: 'root' })

export class ProfileUriService {
  private baseUrl: string;
  private customerUri: CustomerUri;


  constructor(private urlService: UrlService, private apiConfig: AppConfigService) {
    this.baseUrl = environment.baseUrl;
    this.customerUri = apiConfig.appConfig.customerUri;
  }

  getUserProfileUri() {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.user_profile)
  }

  getCompanyProfileUri() {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.profile)
  }

  getUserProfileByIdUri(id) {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.my_customers, id)
  }

  getUserUpdateProfileUri() {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.profile)
  }

  shellInitialUri() {
    return this.urlService.combineUri(this.baseUrl, 'customers', 'initial');
  }
}